import * as Yup from 'yup';
import i18n from 'i18next';

interface Props {
  senha: string;
  newPassword: string;
}

const validarErroForm = async (data: Props) => {
  const schema = Yup.object().shape({
    senha: Yup
      .string()
      .min(6, i18n.t('senha.minimo'))
      .required(i18n.t('senha.obrigatorio')),
    newPassword: Yup
      .string()
      .required(i18n.t('senha.obrigatorio'))
      .oneOf([Yup.ref('senha'), null], i18n.t('senha.senhasIguais')),
  });

  await schema.validate(data, {
    abortEarly: false,
  });
};

export default validarErroForm;
